import React, { Component } from 'react';

import Tab from "../../../components/admin/etc/tab";

import WOSForm from "../../../components/admin/import/wos";
import ScopusForm from "../../../components/admin/import/scopus";
import KCIForm from "../../../components/admin/import/kci";

import { getParams, pushUrl } from '../../../utils/functions'

const vObj = {
  0 : <WOSForm />,
  1 : <ScopusForm />,
  2 : <KCIForm />,
}

const arr = ["WOS 논문 반입", "Scopus 논문 반입", "KCI 논문 반입"];
// ,

class ImportList extends Component {
  constructor(props) {
    super(props);

    const activeTabID = getParams('tab_id') ? getParams('tab_id') : 0;

    this.state = {
      activeTab: activeTabID === null ? 0 : activeTabID
    };
  }

  updateValue = (id) => {
    this.setState({
      activeTab: id
    });

    pushUrl('탭', 'admin.php?page=researchmind-import&tab_id='+id + (getParams('record_id') ? '&record_id=' + getParams('record_id') : ''), null);
  }

  render() {
    const { updateValue } = this;

    return (
      <>
        <div className="container-fluid mt-3 detail-wrap">
          <div className="row">
            <div className="col pl-0 detail scholar-detail">
              <div className="detail-tabs">
                <Tab
                    tabList={arr}
                    changeTab={updateValue}
                    activeID={this.state.activeTab}
                />
              </div>
              <div className="detail-content">
                {
                  vObj[this.state.activeTab]
                }
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default ImportList